export enum TableUserFilter {
    UserStatusFilter = 0,
    UserEnabledFilter = 1,
    UserTenantFilter = 2,
}